import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

export default ({ color = defaultIconColor }: SVGComponentPropsType) => {
  return (
    <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="1" x2="1" y2="24" stroke={color} strokeWidth="2" />
    </svg>
  );
};
